"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _basic_provider = _interopRequireDefault(require("./_basic_provider"));
class IdentifiersApi extends _basic_provider.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      sdkApiUrl,
      providersAccountId,
      accountId
    } = _ref;
    super({
      userTokenFactory,
      sdkApiUrl,
      providersAccountId
    });
    this.accountId = accountId;
    this.axios = this._createAxios();
  }

  /**
   * Get identifiers
   * @param {string=} identifier
   *
   * @async
   */
  async listIdentifiers() {
    let identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    const queryParams = {
      accountId: this.accountId,
      fullInfo: "true",
      groupDetails: "true",
      identifier
    };
    return await this._callApi({
      method: 'get',
      path: `/identifiers`,
      queryParams
    });
  }

  /**
   * Get list of obtainable identifiers
   * @param {Object=} params
   * @param {string} params.country - Two letter country identifier to list number from
   * @param {string} params.region - Two letter state identifier (applicable to US/CA) to list numbers from
   * @param {('local'|'tollfree'|'mobile')} params.type - Phone number type ("local", "tollfree", "mobile")
   * @param {number} params.limit - Limit number of phone numbers in a list
   * @param {string} params.pattern - Set of digits a number should contain, start with or ends with
   * @param {('starts'|'ends'|'contains')} params.patternType - Where the `pattern` should be located relative to the phone number ("starts", "ends", "contains")
   * @param {Array.<'voice'|'sms'|'mms'>} params.capabilities - Array of preferred capabilities ("voice", "sms", "mms")
   * @returns {Object[]}
   * @async
   */
  async getObtainableIdentifiers() {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const queryParams = {
      accountId: this.accountId,
      ...params
    };
    return await this._callApi({
      method: 'get',
      path: `/obtainable-identifiers`,
      queryParams
    });
  }

  /**
   * Remove identifiers
   * @param {string} identifier
   * @async
   */
  async releaseIdentifier(identifier) {
    const queryParams = {
      accountId: this.accountId,
      identifier
    };
    return await this._callApi({
      method: 'delete',
      path: `/identifiers`,
      queryParams
    });
  }

  /**
   * Buy identifiers
   * @param {Array.<{provider: string, phoneNumber: string}>} identifiers
   * @async
   */
  async buyIdentifier(identifiers) {
    const payload = {
      accountId: this.accountId,
      identifiers: Array.isArray(identifiers) ? identifiers : [identifiers]
    };
    return await this._callApi({
      method: 'post',
      path: `/identifiers`,
      payload
    });
  }

  /**
   * Create new provider
   *
   * @param {String} provider - provider name
   * @param {Object} settings - settings object
   * @async
   */
  async createProvider(provider) {
    let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const payload = {
      accountId: this.accountId,
      provider,
      settings
    };
    return await this._callApi({
      method: 'post',
      path: `/identifier-providers`,
      payload
    });
  }

  /**
   * List providers
   * @returns {Object[]}
   * @async
   */
  async listProviders() {
    const queryParams = {
      accountId: this.accountId
    };
    return await this._callApi({
      method: 'get',
      path: `/identifier-providers`,
      queryParams
    });
  }

  /**
   * Remove providers
   *
   * @async
   */
  async removeProviders(provider) {
    const payload = {
      accountId: this.accountId,
      provider
    };
    return await this._callApi({
      method: 'delete',
      path: `/identifier-providers`,
      payload
    });
  }
}
var _default = IdentifiersApi;
exports.default = _default;